import { Auth, token } from "../auth";
import environment from "../environment";
import { createContainer } from "unstated-next";
import { useMutation, useQuery } from "react-query";
import {
  makeAuthedRequest,
  makeAuthedMultipartRequest,
} from "../utils/makeAuthedRequest";

export function useAccount() {
  const { setToken } = Auth.useContainer();

  const login = async ({ employeeNumber, password }) => {
    const isDEV = environment.localDevMode;
    try {
      const response = await fetch(environment.apiBase + `/account/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employeeNumber, password }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || "Failed to login");
      }

      const res = await response.json();
      let token = res.token;

      if (!token) {
        throw new Error("Token is undefined");
      }

      setToken(token); //unclear if this is broken, or not configured locally.

      //adding in a localstorage set here for dev mode (local run)
      if(isDEV){
        localStorage.setItem("bidpro-token", token);
      }

      return token;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    //there is no logout endpoint on the api currently.
    //all logout functionality is expected from the frontend to clear cookies, tokens, etc apparently.
    // const isDEV = environment.localDevMode;

    // if (isDEV) {
    //   document.cookie =
    //     "bidpro-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; //change if on development, etc
    //   localStorage.removeItem("bidpro-token");
    // } else {
    //   document.cookie =
    //     "bidpro-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.bidpro.com"; //change if on development, etc
    // }

    await fetch(environment.apiBase + `/account/logout`, {
      method: "POST",
      credentials: "include",
    }).then((res) => {
      setToken(null);
      localStorage.removeItem("bidpro-token");
    });
    return;
  };
  const validateUser = async () => {
    try {
      const res = await makeAuthedRequest(`/uservalid`, {
        method: "GET",
      });

      if (res.ok) {
        const result = await res.json();
        return result;
      } else {
        const body = await res.json();
        throw new Error(body.error || "Validation failed");
      }
    } catch (error) {
      throw error;
    }
  };
  /*
  const { data: myProfile, refetch: refetchMyProfile } = useQuery(
    ["ProfileGet"],
    async () =>
      await makeAuthedRequest(`/myprofile`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.error);
        }
      })
  );

  const myProfilePost = async (profile) =>
    await makeAuthedRequest(`/myprofile`, {
      method: "POST",
      body: JSON.stringify(profile),
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw body.error;
      }
    });

  const { data: mySecuritySettingsData, refetch: refetchMySecuritySettings } =
    useQuery(
      ["MySecuritySettingsGet"],
      async () => {
        const res = await makeAuthedRequest(`/MySecuritySettings`, {
          method: "GET",
        });

        if (res.ok) {
          const result = await res.json();
          return result;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      },
      {
        enabled: false,
      }
    );

  const updateSecuritySettings = async (securitySettings) => {
    const res = await makeAuthedRequest(`/MySecuritySettings`, {
      method: "POST",
      body: JSON.stringify(securitySettings),
    });

    if (res.ok) {
      const result = await res.json();
      return result;
    } else {
      const body = await res.json();
      throw new Error(body.message);
    }
  };
*/
  return {
    login,
    logout,
    validateUser,
    /*myProfile,
    refetchMyProfile,
    myProfilePost,

    mySecuritySettingsData,
    refetchMySecuritySettings,
    updateSecuritySettings,*/
  };
}
export const AccountContainer = createContainer(useAccount);
